import { PaymentTypes } from './PaymentTypes';
import { Exclude, Transform } from 'class-transformer';

export class PaymentDetailsModel {
    @Transform(val => (val === null ? PaymentTypes.None : val as PaymentTypes))
    public paymentType: PaymentTypes = PaymentTypes.None;

    @Transform(val => (val === null ? 0 : val))
    public cashCardDeposit: number = 0;

    @Transform(val => (val === null ? 0 : val))
    public cashCardPercentage: number = 0;

    @Transform(val => (val === null ? 0 : val))
    public ifcDeposit: number = 0;

    @Transform(val => (val === null ? 0 : val))
    public ifcDepositPercentage: number = 0;

    @Transform(val => (val === null ? 0 : val))
    public ifcMonthlyAmount: number = 0;

    @Transform(val => (val === null ? 0 : val))
    public ifcNumMonths: number = 0;

    @Transform(val => (val === null ? 0 : val))
    public total: number = 0;

    @Exclude()
    public isEmptyModel: boolean = false;
}